import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { interactionSetKeyHeld } from "../../../store/interaction";
export type HeldKeyType = "shift" | "ctrl" | "x" | "y"
const keySetToUppercaseString = {
    shift: "Shift",
    ctrl: "Ctrl",
    x: "x",
    y: "y"
} as const
export type KeySetToUppercaseString = keyof typeof keySetToUppercaseString


export function useButtonHeld(key: HeldKeyType) {
    const dispatch = useDispatch();
    useEffect(() => {
        const keyHeldDown = (e: KeyboardEvent) => {
            //e.preventDefault()
            console.log("keydown", e.key);
            if (e.key === keySetToUppercaseString[key]) {
                dispatch(interactionSetKeyHeld({ key: key, isHeld: true }))
            }
        }
        const shiftUp = (e: KeyboardEvent) => {
            //e.preventDefault()
            console.log("keyup", e.key);
            if (e.key === keySetToUppercaseString[key]) {
                dispatch(interactionSetKeyHeld({ key: key, isHeld: false }))
            }
        }
        console.log("useffectRect");
        window.addEventListener("keydown", keyHeldDown)
        window.addEventListener("keyup", shiftUp)
        return (() => {
            window.removeEventListener("keydown", keyHeldDown)
            window.removeEventListener("keyup", shiftUp)
        })
    }, [key, dispatch])
}